export type VersionResponse = {
  version: string;
};
